<script lang="ts">
  import { onMount } from "svelte";
  import { navigate } from "../../../app.logic";
  import QualityLayout from "../../../layout/QualityLayout.svelte";
  import FormLayout from "../../../layout/FormLayout.svelte";
  import FormField from "../../../components/Form/FormField.svelte";
  import Input from "../../../components/Form/Fields/Input.svelte";
  import Textarea from "../../../components/Form/Fields/Textarea.svelte";
  import Switch from "../../../components/Form/Fields/Switch.svelte";
  import type { IQualityMaintenanceSchedule } from "../../../entities/quality-maintenance-schedule";
  import type { IApiResponse } from "../../../utils/api/api-response";
  import { initDetail, record, save } from "./quality-maintenance-schedule.store";

  export let oid: number;

  $: isNew = oid == 0;
  $: canSubmit = $record != null && $record.description != "" && $record.schedule != ";";

  async function onSubmit() {
    let newP = isNew;
    let _resp: IApiResponse<IQualityMaintenanceSchedule> = await save();
    let u = _resp.payload;
    if (newP) {
      oid = u.oid;
      record.set(u);
      navigate(`/quality-schedule-maintenance/${u.oid}`);
    } else {
      onCancel();
    }
  }

  function onCancel() {
    navigate(`/quality-schedule-maintenance`);
  }

  onMount(() => initDetail(oid));
</script>

<QualityLayout>
  {#if $record}
    <div class="columns" style="margin-top:1rem;">
      <div class="column is-12">
        <FormLayout {canSubmit} {isNew} on:submit={onSubmit} on:cancel={onCancel}>
          <div class="columns">
            <div class="column is-12">
              <FormField>
                <Input name="Descrizione" placeholder="descrizione" required={true} bind:value={$record.description} />
              </FormField>
            </div>
          </div>

          <div class="columns">
            <div class="column is-10">
              <FormField>
                <Input name="scadenza" placeholder="scadenza" required={true} bind:value={$record.schedule} />
              </FormField>
            </div>
            <div class="column is-2">
              <FormField>
                <Switch name="Interna" bind:value={$record.internal} />
              </FormField>
            </div>
          </div>

          <div class="columns">
            <div class="column is-12">
              <FormField>
                <Textarea name="Note" placeholder="note" required={false} bind:value={$record.notes} />
              </FormField>
            </div>
          </div>
        </FormLayout>
      </div>
    </div>
  {/if}
</QualityLayout>
